export default __webpack_public_path__ + "static/comunicacion-df38f1a7f39278966dd2c3d3d492fe72.png";